export const LIST_SERVICE_CATEGORY_REQUEST = 'LIST_SERVICE_CATEGORY_REQUEST'
export const LIST_SERVICE_CATEGORY_SUCCESS = 'LIST_SERVICE_CATEGORY_SUCCESS'
export const LIST_SERVICE_CATEGORY_FAIL = 'LIST_SERVICE_CATEGORY_FAIL'

export const LIST_SERVICE_CATEGORY_SUMMARY_REQUEST = 'LIST_SERVICE_CATEGORY_SUMMARY_REQUEST'
export const LIST_SERVICE_CATEGORY_SUMMARY_SUCCESS = 'LIST_SERVICE_CATEGORY_SUMMARY_SUCCESS'
export const LIST_SERVICE_CATEGORY_SUMMARY_FAIL = 'LIST_SERVICE_CATEGORY_SUMMARY_FAIL'

export const CREATE_SERVICE_CATEGORY_REQUEST = 'CREATE_SERVICE_CATEGORY_REQUEST'
export const CREATE_SERVICE_CATEGORY_SUCCESS = 'CREATE_SERVICE_CATEGORY_SUCCESS'
export const CREATE_SERVICE_CATEGORY_FAIL = 'CREATE_SERVICE_CATEGORY_FAIL'

export const DETAIL_SERVICE_CATEGORY_REQUEST = 'DETAIL_SERVICE_CATEGORY_REQUEST'
export const DETAIL_SERVICE_CATEGORY_SUCCESS = 'DETAIL_SERVICE_CATEGORY_SUCCESS'
export const DETAIL_SERVICE_CATEGORY_FAIL = 'DETAIL_SERVICE_CATEGORY_FAIL'

export const UPDATE_SERVICE_CATEGORY_REQUEST = 'UPDATE_SERVICE_CATEGORY_REQUEST'
export const UPDATE_SERVICE_CATEGORY_SUCCESS = 'UPDATE_SERVICE_CATEGORY_SUCCESS'
export const UPDATE_SERVICE_CATEGORY_FAIL = 'UPDATE_SERVICE_CATEGORY_FAIL'

export const DELETE_SERVICE_CATEGORY_REQUEST = 'DELETE_SERVICE_CATEGORY_REQUEST'
export const DELETE_SERVICE_CATEGORY_SUCCESS = 'DELETE_SERVICE_CATEGORY_SUCCESS'
export const DELETE_SERVICE_CATEGORY_FAIL = 'DELETE_SERVICE_CATEGORY_FAIL'

export const RESET_SERVICE_CATEGORY = 'RESET_SERVICE_CATEGORY'
